import { render, staticRenderFns } from "./po-base-list.vue?vue&type=template&id=fc32d4a8&"
import script from "./po-base-list.vue?vue&type=script&lang=ts&"
export * from "./po-base-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports